export type { SlideProps } from "./Slide";
export { default as Slide } from "./Slide";
export type { SliderProps } from "./Slider";
export { default, SliderActions } from "./Slider";
